import React from "react";
import { Avatar } from "@material-ui/core";
import { toImageUrl } from "../../../../../utils/formatHelper";
import SwitchIOS from "../../../../components/SwitchIOS";

export const initialBannerTableOptions = {
    pageSize: 20,
    pageSizeOptions: [5, 10, 20, 50],
    actionsColumnIndex: -1,
    emptyRowsWhenPaging: false,
    headerStyle: {
        fontSize: 15,
    },
    debounceInterval: 500,
    // have not affect table
    totalData: 0,
    order: "",
    direction: "",
};

export const getBannerColumns = params => {
    return [
        {
            title: "Start Date",
            field: "startDate",
        },
        {
            title: "End Date",
            field: "endDate",
        },
        {
            title: "Image",
            field: "image",
            sorting: false,
            render: rowData => <Avatar variant="rounded" alt="promotionBannerImage" src={toImageUrl(rowData?.image)} />,
        },
        {
            title: "Status",
            field: "status",
            sorting: false,
            render: rowData => (
                <SwitchIOS
                    color="default"
                    checked={rowData?.status}
                    onChange={() =>
                        params?.handleChangeBannerStatus({
                            checked: !rowData?.status,
                            id: rowData?.homeBannerId,
                        })
                    }
                    disabled={!params?.thisMenuPermission?.edit}
                />
            ),
        },
    ];
};
